<template>
  <div class="Home">
    <!--    轮播start-->
    <div class="site-header-slider">
      <el-carousel height="400px">
        <el-carousel-item v-for="(item,index) in swiperList" :key="index">
          <img class='swiper-img' :src='item.img'/>
        </el-carousel-item>
      </el-carousel>
      <!--      注册登录入口start-->
      <div class="homeIndex"  v-show="!$store.state.loginType">
        <div class="banner">
          <div class="wrapOne">
            <div class="entrance" style="width:400px;">
              <div class="register selected" id="entranceRegister">
<!--                <div class="big" style="font-size:21px;color:black;margin-top:28px;"></div>-->
               <!-- <h1 class="head" style="font-size:28px;color:red;">新用户注册即送 </h1>

                <div class="percent" style="padding:10px;font-size:18px;color:black;">
                  代金券<span style="color:red;">3999元</span>+交易红包<span style="color:red;">9999元</span>
                </div>

                <p class="tt" style="padding:5px;font-size:18px;color:#11181f;margin-top:10px;">资金100%双重保障，100%实盘交易</p>-->
                <h1 class="head" style="font-size:28px;color:red;margin-bottom:3px;"><span>新会员最高专享礼</span></h1>
<!--                <p style="margin-bottom:3px;">~最高可领~</p>-->
                <div class="percent" style="padding:10px;font-size:18px;color:black;padding-top:0px;padding-bottom:0px;margin-bottom:3px;">
                  注册送<span style="color:red;">{{sys_give_voucher_amount}}元</span>
                </div>
<!--                <p>券商实盘 专业安全 认证品牌</p>-->
<!--                <div class="percent" style="padding:10px;font-size:18px;color:black;padding-top:0px;padding-bottom:0px;margin-bottom:3px;font-weight:bold">-->
<!--                  注册<span style="color:red;">&nbsp;<b>{{sys_give_voucher_amount}}</b>&nbsp;元</span>&nbsp;<b>+</b>&nbsp;首充&nbsp;<span style="color:red;"><b>10000</b>&nbsp;元&nbsp;</span><b>+</b>&nbsp;交易&nbsp;<span style="color:red;">&nbsp;<b>9999</b>&nbsp;元</span>-->
<!--                </div>-->
               <p style="margin-top:20px;"><span>券商实盘 专业安全 认证品牌</span></p>
              </div>
              <div class="goAccount" id="entranceAccount" style="margin-top:0px;">
                <router-link to="/login" class="btn" id="goLogin">
                  立即登录
                </router-link>
                <router-link to="/login/register" class="btn" id="goRegister" style="margin-left:15px;">
                  立即注册
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--      注册登录入口end-->
    </div>


    <!--    轮播end-->
    <div class="wrapper">


      <!--      跑马灯start-->
      <div class="scroll_news">
        <span class="text-danger iconfont">&#xe630; &nbsp;公告</span>
        <marquee scrollamount="5" scrolldelay="0" direction="left" class="scroll_con" onmouseout="this.start()" @click="changeNoticeStatus"
                 onstart="this.firstChild.innerHTML+=this.firstChild.innerHTML;" onmouseover="this.stop()">
          {{ notice.name }}
        </marquee>
      </div>
      <!--      跑马灯end-->
      <!--      提示start-->
      <div class="newbee">
        <div class="wrapper clearfix">
          <div class="item">
            <div class="figure">
              <img src="../assets/img/icon-1.png" alt="">
            </div>
            <div class="item-body">
              <div class="title">资金保障</div>
              <div class="text">资金第三方监管,专款专用</div>
            </div>
          </div>
          <div class="item">
            <div class="figure">
              <img src="../assets/img/icon-2.png" alt="">
            </div>
            <div class="item-body">
              <div class="title">真实交易</div>
              <div class="text">100%实盘,同步股市数据</div>
            </div>
          </div>
          <div class="item">
            <div class="figure">
              <img src="../assets/img/icon-3.png" alt="">
            </div>
            <div class="item-body">
              <div class="title">快捷提现</div>
              <div class="text">闪电提现,最快三分钟到账</div>
            </div>
          </div>
          <div class="item">
            <div class="figure">
              <img src="../assets/img/icon-4.png" alt="">
            </div>
            <div class="item-body">
              <div class="title">专业服务</div>
              <div class="text">客户体验至上为宗旨</div>
            </div>
          </div>
        </div>
      </div>
      <!--      提示end-->
      <!--      配资start-->
      <div class="main_peizi w1200">
        <div class="main_peizi1  fl">
          <div class="main_peizi1_t"><img src="../assets/img/aypz2.png"><span>按月配资</span></div>
          <div class="main_peizi1_c1">
            <div class="main_peizi1_c1_left fl">
              <p class="main_peizi1_p1">利率低至</p>
              <p class="main_peizi1_p2" id="m-min-day">100元/1万</p>
            </div>
            <div class="main_peizi1_c1_right fr">
              <p class="main_peizi1_p1">独立成户</p>
              <p class="main_peizi1_p2">稳定高效</p>
            </div>
          </div>
          <div class="main_peizi1_c2 main_peizi1_c3">
            <span><b id="day-max-bzj">200</b>万元</span>
            <div class="black">最高保证金</div>
          </div>
          <div class="main_peizi1_c2">
            <span><b id="day-min-bzj">1000</b>元</span>
            <div class="black">起配金额</div>
          </div>
          <router-link to="/operate/operatemonth" class="main_peizi1_a">
            我要配资
          </router-link>
          <div class="main_peizi1_p3">资金三方托管/保险双保障/全实盘交易</div>
        </div>
        <div class="main_peizi1 main_peizi4 fl">
          <div class="main_peizi1_t"><img src="../assets/img/azpz.png"><span>按周配资</span></div>
          <div class="main_peizi1_c1">
            <div class="main_peizi1_c1_left fl">
              <p class="main_peizi1_p1">利率低至</p>
              <p class="main_peizi1_p2" id="m-min-vip">30元/1万</p>
            </div>
            <div class="main_peizi1_c1_right fr">
              <p class="main_peizi1_p1">独立成户</p>
              <p class="main_peizi1_p2">稳定高效</p>
            </div>
          </div>
          <div class="main_peizi1_c2 main_peizi1_c3">
            <span><b id="m-max-bzj">200</b>万元</span>
            <div class="black">最高保证金</div>
          </div>
          <div class="main_peizi1_c2">
            <span><b id="m-min-bzj">1000</b>元</span>
            <div class="black">起配金额</div>
          </div>
          <router-link to="/operate/operateweek" class="main_peizi1_a">
            我要配资
          </router-link>
          <div class="main_peizi1_p3">资金三方托管/保险双保障/全实盘交易</div>
        </div>
        <div class="main_peizi1 main_peizi2 fl">
          <div class="main_peizi1_t"><img src="../assets/img/atpz.png"><span>按天配资</span></div>
          <div class="main_peizi1_c1">
            <div class="main_peizi1_c1_left fl">
              <p class="main_peizi1_p1">利率低至</p>
              <p class="main_peizi1_p2" id="m-min-week">6元/1万</p>
            </div>
            <div class="main_peizi1_c1_right fr">
              <p class="main_peizi1_p1">独立成户</p>
              <p class="main_peizi1_p2">稳定高效</p>
            </div>

          </div>
          <div class="main_peizi1_c2 main_peizi1_c3">
            <span><b id="week-max-bzj">200</b>万元</span>
            <div class="black">最高保证金</div>
          </div>
          <div class="main_peizi1_c2">
            <span><b id="week-min-bzj">1000</b>元</span>
            <div class="black">起配金额</div>
          </div>
          <router-link to="/operate/operateday" class="main_peizi1_a">
            我要配资
          </router-link>
          <div class="main_peizi1_p3">资金三方托管/保险双保障/全实盘交易</div>
        </div>
        <div class="main_peizi1 main_peizi3 fl">
          <div class="main_peizi1_t"><img src="../assets/img/mxpz.png"><span>免息配资</span></div>
          <div class="main_peizi1_c1">
            <div class="main_peizi1_c1_left fl">
              <p class="main_peizi1_p1">不收取利息</p>
              <p class="main_peizi1_p2">全免</p>
            </div>
            <div class="main_peizi1_c1_right fr">
              <p class="main_peizi1_p1">收益分成</p>
              <p class="main_peizi1_p2">盈利<label id="mx-ylfc">88</label>%归您</p>
            </div>
          </div>
          <div class="main_peizi1_c2 main_peizi1_c3">
            <span><b id="mx-max-bzj">200</b>万元</span>
            <div class="black">最高保证金</div>
          </div>
          <div class="main_peizi1_c2">
            <span><b id="mx-min-bzj">1000</b>元</span>
            <div class="black">起配金额</div>
          </div>
          <router-link to="/operate/operatehuhui" class="main_peizi1_a">
            我要配资
          </router-link>
          <div class="main_peizi1_p3">资金三方托管/保险双保障/全实盘交易</div>
        </div>
      </div>
      <!--      配资end-->
      <!--      指数start-->
      <div id="app-stock-rank" class="block-stock-info box-shadow">
        <el-row :gutter="30">
          <el-col :span="12">
            <h1 class="block-name block-trade-type">
              <a href="javascript:void(0);" @click="show_trade_chart_by_type('SH')"
                 :class="{ active: 'SH' === trade_exchange_type }">
                <span>上证指数</span>
              </a>
              <a href="javascript:void(0);" @click="show_trade_chart_by_type('SZ')"
                 :class="{ active: 'SZ' === trade_exchange_type }">
                <span>深证指数</span>
              </a>
            </h1>
            <div class="stock-chart">
              <div class="img-stock">
                <img :src="SinaGIF" id="img-stock" title="点击更新" @click="show_trade_chart()">
              </div>
              <ul class="nav nav-pills nav-chart-time justify-content-center">
                <li class="nav-item">
                  <a href="javascript:void(0);" @click="show_trade_chart_by_time('min')" class="nav-link"
                     :class="{ active:'min' === trade_chart_type }">分时线</a>
                </li>
                <li class="nav-item">
                  <a href="javascript:void(0);" @click="show_trade_chart_by_time('daily')" class="nav-link"
                     :class="{ active:'daily' === trade_chart_type }">日K线</a>
                </li>
                <li class="nav-item">
                  <a href="javascript:void(0);" @click="show_trade_chart_by_time('weekly')" class="nav-link"
                     :class="{ active:'weekly' === trade_chart_type }">周K线</a>
                </li>
                <li class="nav-item">
                  <a href="javascript:void(0);" @click="show_trade_chart_by_time('monthly')" class="nav-link"
                     :class="{ active:'monthly' === trade_chart_type }">月K线</a>
                </li>
              </ul>
            </div>
          </el-col>
          <el-col :span="6">
            <h1 class="block-name"><a class="active"><span>领涨股</span></a></h1>
            <div class="thin-scroll">
              <table class="table table-sm table-stock">
                <thead>
                <tr>
                  <th scope="col">股票名称</th>
                  <th class="text-right">最新价</th>
                  <th class="text-right">涨跌幅</th>
                  <th class="text-right">最高</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in upStock" :key="index">
                  <td><small>{{ item.name }}</small></td>
                  <th class="text-right"><small class="text-primary">{{ item.zhi1 }}</small></th>
                  <td class="text-right"><small class="text-danger">{{ item.zhi2 }}</small></td>
                  <td class="text-right"><small class="text-danger">{{item.zhi3}}</small></td>
                </tr>
                </tbody>
              </table>
            </div>
          </el-col>
          <el-col :span="6">
            <h1 class="block-name block-name-green"><a class="active"><span>领跌股</span></a></h1>
            <div>
              <table class="table table-sm table-stock">
                <thead>
                <tr>
                  <th scope="col">股票名称</th>
                  <th class="text-right">最新价</th>
                  <th class="text-right">涨跌幅</th>
                  <th class="text-right">最低</th>
                </tr>
                </thead>
                <tbody v-for="(item,index) in downStock" :key="index">
                <tr>
                  <td><small>{{ item.name }}</small></td>
                  <th class="text-right"><small class="text-primary">{{ item.zhi1 }}</small></th>
                  <td class="text-right"><small class="text-success">{{ item.zhi2 }}</small></td>
                  <td class="text-right"><small class="text-danger">{{item.zhi3}}</small></td>
                </tr>
                </tbody>
              </table>
            </div>
          </el-col>
        </el-row>
      </div>
      <!--      指数end-->

      <!--      广告位start-->
      <router-link to="/operate" class="down_ad">
        <img src="../assets/img/trial.gif" style="width: 100%;">
      </router-link>
      <!--      广告位end-->
      <!--      计划表start-->
      <div class="w1200 wrapper plan3" style="margin-bottom: 16px;margin-top: 15px; width: 1200px">
        <div class="plan-right" style="width:100%;">
          <!-- 今日注册 -->
          <div class="pr-left pr-jrzc">
            <div class="prl-block" style="padding-left: 10px;background-color: #fff">
              <div class="prl-title">
                <p style="color:red;">
                  注册会员&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp操盘达人</p>
              </div>
              <div class="prl-li">
                <div class="tempWrap" style="overflow:hidden; position:relative; height:312px">
                  <ul id="new_reg" class=""
                      style="position: relative;padding: 0px;margin: 0px;overflow-y: scroll;max-height: 300px;overflow: hidden;">
                    <!-- <marquee direction="up" scrollamount=3> -->
                    <li style="height: 40px;">
                      <span class="li-l">181******9373</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">137******9382</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">158******6154</span>
                      <span class="li-r">配资17万实盘资金盈利1.7万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">159******5485</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">151******0018</span>
                      <span class="li-r">配资6万实盘资金盈利1.62万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">132******3168</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">166******5345</span>
                      <span class="li-r">配资5万实盘资金盈利0.8万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">138******7588</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">138******7391</span>
                      <span class="li-r">配资61万实盘资金盈利4.88万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">156******5123</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">199******2805</span>
                      <span class="li-r">配资420万实盘资金盈利85.6万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">181******1852</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">138******3045</span>
                      <span class="li-r">配资300万实盘资金盈利69万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">150******9863</span>
                      <span class="li-r">配资500万实盘资金盈利86万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">135******7455</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">155******1706</span>
                      <span class="li-r">配资150万实盘资金盈利40.5万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">182******1863</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">185******4308</span>
                      <span class="li-r">配资200万实盘资金盈利72万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">166******0551</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">199******5159</span>
                      <span class="li-r">配资6万实盘资金盈利1.28万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">191******9632</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">131******2999</span>
                      <span class="li-r">配资5万实盘资金盈利0.8万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">131******8352</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">185******8221</span>
                      <span class="li-r">配资320万实盘资金盈利62.4万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">139******5255</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">152******9898</span>
                      <span class="li-r">配资60万实盘资金盈利20.4万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">130******9884</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">139******0801</span>
                      <span class="li-r">配资40万实盘资金盈利14万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">188******1522</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">155******8738</span>
                      <span class="li-r">配资10万实盘资金盈利3.5万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">199******5056</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">187******9215</span>
                      <span class="li-r">配资80万实盘资金盈利19.84万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">131******8833</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">186******9968</span>
                      <span class="li-r">配资15万实盘资金盈利2.79万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">188******1137</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">136******8585</span>
                      <span class="li-r">配资6万实盘资金盈利1.62万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">152******2109</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">158******5644</span>
                      <span class="li-r">配资6万实盘资金盈利1.28万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">150******3576</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">189******2269</span>
                      <span class="li-r">配资88万实盘资金盈利22.88万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">182******5918</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">139******8785</span>
                      <span class="li-r">配资1万实盘资金盈利0.2万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">177******1164</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">182******6642</span>
                      <span class="li-r">配资6万实盘资金盈利0.9万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">155******3146</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">132******1610</span>
                      <span class="li-r"> 配资5万实盘资金盈利0.76万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">134******5511</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">158******8288</span>
                      <span class="li-r"> 配资140万实盘资金盈利23.8万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">155******5889</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">136******3707</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">132******6836</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">132******2723</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">189******9580</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">136******2065</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">152******5842</span>
                      <span class="li-r">配资150万实盘资金盈利15.6万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">131******5815</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">175******0811</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">135******1754</span>
                      <span class="li-r">配资128万实盘资金盈利23.8万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">136******1578</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">182******2958</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">132******2107</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">130******6638</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">131******7885</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">131******2903</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">131******2777</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">177******4007</span>
                      <span class="li-r">配资340万实盘资金盈利48.8万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">182******0177</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">181******8866</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">188******8888</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">180******9917</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">131******0999</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">180******1021</span>
                      <span class="li-r">配资320万实盘资金盈利35.5万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">151******9159</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">182******0067</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">133******8624</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">158******8169</span>
                      <span class="li-r">配资320万实盘资金盈利42.3万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">130******0484</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">136******4975</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">135******9423</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">151******2879</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">177******6131</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">159******4118</span>
                      <span class="li-r">配资140万实盘资金盈利23.8万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">158******9118</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">139******3227</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">183******8335</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">151******1984</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">180******2351</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">178******2673</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">130******9138</span>
                      <span class="li-r"> 配资130万实盘资金盈利15.8万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">171******2580</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">199******7655</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">151******6075</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">135******8235</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">189******9473</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">182******1545</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">181******7858</span>
                      <span class="li-r">配资140万实盘资金盈利23.8万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">133******6978</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">180******1006</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">181******2802</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">159******2693</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">135******5138</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">******</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">189******4599</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">181******7758</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">138******7615</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">135******7379</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">130******6335</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">134******0851</span>
                      <span class="li-r">配资88万实盘资金盈利22.88万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">139******8324</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">133******4242</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">182******8973</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">176******4530</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">131******2408</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">180******2505</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">131******7128</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">182******0146</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">132******3348</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">199******3524</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">151******9799</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">137******3128</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">139******1068</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">136******5241</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">185******5993</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">159******3747</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">180******4237</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">189******7060</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">178******3968</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">150******7995</span>
                      <span class="li-r">配资15万实盘资金盈利2.6万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">136******7531</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">183******8054</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">151******4649</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">135******8524</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">150******2560</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">138******5656</span>
                      <span class="li-r">配资88万实盘资金盈利22.88万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">188******2998</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">182******6642</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">180******0890</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">137******9294</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">157******4398</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">176******5644</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">181******2084</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">139******0705</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">159******4556</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">178******2863</span>
                      <span class="li-r">配资12万实盘资金盈利1.88万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">188******0599</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">134******2519</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">151******2517</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">176******6380</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">171******0415</span>
                      <span class="li-r">配资66万实盘资金盈利12.88万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">187******7849</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">147******0207</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">152******5759</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">137******1716</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">139******7659</span>
                      <span class="li-r">配资2万实盘资金盈利0.25万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">176******5727</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">158******7206</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">152******2755</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">152******3704</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">138******0046</span>
                      <span class="li-r">配资41万实盘资金盈利8.3万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">156******3551</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">181******2156</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">186******9264</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">157******9210</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">155******6668</span>
                      <span class="li-r">配资7万实盘资金盈利0.65万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">152******7565</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">180******3836</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">153******7450</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">153******0999</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">188******5236</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">136******6512</span>
                      <span class="li-r">配资7万实盘资金盈利0.8万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">131******1412</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">186******5079</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">159******1377</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">171******2698</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">198******8562</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">188******6391</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">157******3520</span>
                      <span class="li-r">配资4万实盘资金盈利0.42万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">177******5399</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">136******3926</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">177******9495</span>
                      <span class="li-r"> 今日已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">135******2033</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">185******0404</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">159******4466</span>
                      <span class="li-r">配资35万实盘资金盈利2.8万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">135******4047</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">138******0409</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">180******9805</span>
                      <span class="li-r">配资6万实盘资金盈利0.3万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">131******0763</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">182******6031</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">130******7319</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">178******1103</span>
                      <span class="li-r">配资45万实盘资金盈利2.6万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">131******0371</span>
                      <span class="li-r">配资32万实盘资金盈利3万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">182******4448</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">178******0907</span>
                      <span class="li-r">配资50万实盘资金盈利4.6万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">189******6979</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">189******1260</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">178******8920</span>
                      <span class="li-r">配资12万实盘资金盈利1.2万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">186******6161</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">183******1018</span>
                      <span class="li-r">配资8万实盘资金盈利0.88万</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">151******1978</span>
                      <span class="li-r"> 近期已注册成功</span>
                      <p style="clear:both;"></p>
                    </li>
                    <!-- </marquee> -->
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!--  新闻 -->
          <div class="app-d pr-left pr-jrzc pb6">
            <div class="pb6-r fl">
              <div class="gonggaoBox">

                <div id="hd_two" class="dd">
                  <p class="dd_line">
                    <span class="active">新闻动态</span>
                  </p>
                  <el-row>
                    <el-col :span="22" :offset="1">
                      <div class="panel-news-list">
                        <ul class="list-group list-group-flush">

                          <li class="list-group-item" v-for="(item,index) in news" :key="index">
                            <span>{{ item.modify_time }}</span>
                            <a href="javascript:void(0)" @click="toDetail(index)">{{ item.title }}</a>
                          </li>
                          <li class="list-group-item text-right">
                            <router-link to="/news">
                              更多
                            </router-link>
                            <!--                            <a href="/content/knownlege.html">更多...</a>-->
                          </li>
                        </ul>
                      </div>
                    </el-col>
                  </el-row>
                </div>


              </div>

              <div style="clear: both;"></div>
            </div>
          </div>

          <!-- 今日充值 -->
          <div class="pr-left pr-jrcz" style="float:right;margin-right: 10px; width: 358px">
            <div class="prl-block" style="padding-left: 10px;background-color: #fff">
              <div class="prl-title">
                <p style="color:red;">今日充值</p>
              </div>
              <div class="prl-li">
                <div class="tempWrap" style="overflow:hidden; position:relative; height:312px">
                  <ul id="reload_list" style="position: relative;padding: 0px;margin: 0px;overflow-y: scroll;max-height: 300px;overflow: hidden;">
                    <!-- <marquee direction="up" scrollamount=3> -->
                    <li style="height: 40px;">
                      <span class="li-l">*********8021</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值2000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********4203</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********4538</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********7181</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********1535</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值5000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********7728</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值2000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********7088</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********7092</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********8863</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2920</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********7666</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2738</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0559</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********4799</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值5000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********8283</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3920</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********9770</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********9991</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值51000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0782</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0747</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********1318</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2408</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3185</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2790</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3114</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6623</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2815</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********1266</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值2000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********5453</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2699</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********4588</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********8768</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3323</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0638</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********1999</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值5019元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********7433</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********1976</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值2000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********5351</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********7668</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值100000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3279</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********8029</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值20000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3557</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值50000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********7190</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6730</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2494</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值100000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6823</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1500元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2659</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3332</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值2000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3098</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********5609</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值20000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2172</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6039</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0670</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********5276</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值15000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2570</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********9529</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3557</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值50000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0826</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值5000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********5268</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值2200元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6248</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********5676</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********8882</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1342元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3689</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********7308</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********4150</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6630</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********5245</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3518</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0869</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0966</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********9829</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********8700</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值4799.5元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********7309</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6366</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3249</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********8369</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值50000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********9183</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6195</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值2000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0999</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********8007</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0021</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6727</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********4086</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值50000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********1837</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值50000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********8445</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值5000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********9509</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2445</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值12000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0930</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2297</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值5112元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********1314</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值5000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3057</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值50000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********8131</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0899</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********1012</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********1922</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值5000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0234</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6858</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值3000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********1687</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0999</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值2000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********5138</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********5858</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0769</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6437</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********9303</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********1409</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********4240</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********8376</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10001元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2231</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6595</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********1126</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0259</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6164</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********5727</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********7399</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3196</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2280</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6425</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值5000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********4505</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2488</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值5000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0595</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2122</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值5000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********5079</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值20000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********5481</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值2000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********9572</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1100元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********4259</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10130元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********5180</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10080元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3777</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10120元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********7589</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值3000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********7742</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2096</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值2000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6188</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值3000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3506</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0733</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********7888</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值5068元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0573</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********8559</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********5805</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值100元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0603</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********7681</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********1757</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值50000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********4860</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3285</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********9598</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2252</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********5916</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********8631</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1009元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0277</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6694</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值2000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3105</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10012元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6359</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0999</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值2000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6292</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********8765</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********8329</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10003元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********7967</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值11000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********9394</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********1353</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值100000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3335</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2227</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1012元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********9728</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0088</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值2000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********7116</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值3000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********7330</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********9671</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********5283</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值2000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0467</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值5000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********5006</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0678</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********8715</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********1885</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2689</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2954</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6619</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0072</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********7398</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********7085</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值500000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********4458</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********8115</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********5509</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********5493</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1800元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6225</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0621</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值2000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3066</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********9822</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********1115</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********8873</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********4731</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********9816</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********9967</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********9859</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********6411</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********9016</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3342</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********0845</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2460</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********2921</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值10000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3502</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********4565</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********3558</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值5000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <li style="height: 40px;">
                      <span class="li-l">*********8987</span>
                      <!--<span class="li-l"></span>-->
                      <span class="li-r">充值1000元</span>
                      <p style="clear:both;"></p>
                    </li>
                    <!-- </marquee> -->
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="clear:both;"></div>
      </div>
      <!--      计划表end-->
      <div class="container-w">

        <div class="block-links box-shadow">
          <h1 class="block-name">
            <a class="active"><span>合作伙伴</span></a>
          </h1>
          <div class="links">
            <a href="https://stock.pingan.com/" target="_blank">
              <img src="../assets/img/a81f2971daf4b36bf4f618431b64b436.jpg" alt="平安證券">
            </a>
            <a href="https://www.citics.com" target="_blank">
              <img src="../assets/img/3bdab206242fdace1e419204cce1b99c.jpg" alt="中信證券">
            </a>
            <a href="http://www.newone.com.cn/" target="_blank">
              <img src="../assets/img/d525aa049f7b8881a318eb9167d32406.jpg" alt="招商證券">
            </a>
            <a href="https://www.htsc.com.cn/htzq/index/index.jsp" target="_blank">
              <img src="../assets/img/7305b3d71dd4c33e1e5d8c44937287d4.jpg" alt="华泰證券">
            </a>
            <a href="http://www.chinastock.com.cn/" target="_blank">
              <img src="../assets/img/4cc757eff73ac5c933a94725de32e890.jpg" alt="银河證券">
            </a>
            <a href="http://www.gf.com.cn/" target="_blank">
              <img src="../assets/img/7f5a8d7d7597ed9df6ada8f1eee25122.jpg" alt="广发證券">
            </a>
            <a href="http://www.eastmoney.com/" target="_blank">
              <img src="../assets/img/91690f0fe4a96f746f80360fe0a37d6f.jpg" alt="东方财富">
            </a>
            <a href="https://www.htsec.com/" target="_blank">
              <img src="../assets/img/4b5375d77019d8aa76707d1357001987.jpg" alt="海通證券">
            </a>
            <a href="https://www.boc.cn/" target="_blank">
              <img src="../assets/img/c55cf16a3a77215f7335e2b96bba924e.jpg" alt="中国银行">
            </a>
            <a href="http://www.cmbc.com.cn/" target="_blank">
              <img src="../assets/img/100350c52f2cca4dd74ec6a80d8b02f2.jpg" alt="民生银行">
            </a>
            <a href="https://www.alipay.com/" target="_blank">
              <img src="../assets/img/99371acec430fc7d721a9e96c140b013.png" alt="支付宝">
            </a>
            <a href="https://www.baidu.com/" target="_blank">
              <img src="../assets/img/db55e404c3302c472d5053ea5b0eeddc.jpg" alt="百度">
            </a>
          </div>
        </div>


      </div>


    </div>
    <!--    右侧悬浮start-->
    <div class="float">
      <ul id="toTopUl">
        <li>
          <a class="flo_1" href="javascript:void(0);" @click="loadChatPopup" title="点击联系客服">
            <span class="ke_tit">在线客服</span>
          </a>
        </li>
        <li>
          <a class="flo_2" href="javascript:void(0);" style="font-size: 14px; width: 60px; opacity: 1; background-position: center 6px;">
            <span class="ke_tit">电话</span>
          <span class="ke_info">{{ info.phone[0] }}</span>
          </a>
        </li>
        <li><a class="flo_qq" href="javascript:void(0);"> <span class="ke_tit">QQ客服</span></a></li>
<!--        <li><a class="flo_3" href="javascript:void(0);"><span class="ke_tit">微信</span></a></li>-->
        <li><a class="flo_w" href="javascript:void(0);"><span class="ke_tit">app下载</span></a></li>
        <li id="atop"><a class="flo_4" href="javascript:void(0);"><span class="ke_tit">返回</span></a></li>
      </ul>
      <div class="flqrc wxqrc"><p>
        <!-- <img src="../assets/img/wx1.png"> -->
        <img src="../assets/img/wx1.png"/>
        </p></div>
      <div class="flqrc appqrc"><div id="floatQrCode"></div></div>
      <div class="flqrc qqqrc">
        <li style="margin: 7px 0; color:red;" v-for="(item,index) in info.qq" :key="index">
          <span v-if="index === 0">客服QQ：</span><span v-else>代理QQ：</span>{{ item[0] }}
          <a target="_blank" :href="item[1]">
            <!-- <img src="../assets/img/qq1.gif" width="50px"> -->
            <img src="../assets/img/qq1.gif"/>
          </a>
        </li>
      </div>
    </div>
    <!--<div class="sidebar">
      <div class="sidebar-li backtop"></div>
      <div class="sidebar-li informationClick">
        <img src="../assets/img/phonezx.png">
        <span>热线电话</span>
      </div>
      <div class="sidebar-li downloadClick">
        <img src="../assets/img/apponload.png">
        <span>APP下载</span>
      </div>
      &lt;!&ndash; <div class="sidebar-li wechatClick" @click="fadeShow(3)">
        <img src="../assets/img/wechatgzh.png">
        <span>微信公众号</span>
      </div> &ndash;&gt;
      <div class="sidebar-li backbottom"></div>
    </div>-->


    <!--    右侧悬浮end-->
  <!--  <HomePhone class="home-phone" :phone1="phone[0]" :phone2="phone[1]"></HomePhone>
    <HomeDown class="home-down" :code="codes"></HomeDown>-->
    <!-- <HomeWx
      class="home-wx"
      :img1="codes[2].code"
      :title1="codes[2].title"
      :img2="codes[1].code"
      :title2="codes[1].title"
    ></HomeWx> -->

    <el-dialog
      :visible.sync="popupStatus"
      width="565px">
      <div class="popupContent" v-html="popup.content">

      </div>
      <span slot="footer" class="dialog-footer"></span>
<!--      <img :src="popupImg" style="width: 100%">-->
    </el-dialog>

    <el-dialog
      :visible.sync="noticeStatus"
      width="800px">
      <div v-html="notice.content">

      </div>
    </el-dialog>
     <el-dialog id="chatPopupId"
      :visible.sync="chatPopupStatus"
      width="800px">
      <span slot="title">大牛客服</span>
      <div class="popupContent">
        <iframe :src="server_url" frameborder="0" width="100%" height="600px">

        </iframe>
      </div>
    </el-dialog>


  </div>
</template>
<script>
  import $ from "jquery";
  import "./../assets/css/animate.min.css";

  import QRCode from 'qrcodejs2'


  //window.setInterval(show_trade_chart, 30000);

  export default {
    name: "Home",
    components: {
    },
    computed:{
    },
    data() {
      return {
        swiperList: [],
        listData: ['item1', 'item2', 'item3'],
        notice: {
          content:'',
          name:'',
          time:'',

        },
        noticeStatus:false,
        trade_exchange_type: 'SH',
        trade_chart_type: 'min',//daily,weekly,monthly
        SinaGIF: '',
        news: [],
        upStock: [],
        downStock: [],
        info:{
          phone:[],
          codes:[],
          qq:[]
        },
        popupStatus:false,
        chatPopupStatus:false,
        popup:{
          content:'',
          popup_status:'0'
        },
        server_url:'',
        user_number: '',
        chatToken: '',
        sys_give_voucher_amount: "",
        profitBanner: '',
        sz_kline_chart:'',
        sh_kline_chart:'',
      };
    },
    methods: {
      realNameConfig() {
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "sysconfig",
                  token: sessionStorage.getItem("token"),
                  name:"sys_give_voucher_amount"
                }
              })
              .then(function(res) {
                if (res.data.code == 1) {
                  //first time Recharge
                    that.sys_give_voucher_amount = res.data.data;
                  // that.isFirstTimeTrading = false;
                  // localStorage.setItem("isFirstTimeRecharge", false);
                } else {
                  // that.isFirstTimeTrading = true;
                  // localStorage.setItem("isFirstTimeRecharge", true);

                }
              });
        },
      serverUrl(){
        let that = this;
        that.$http({
          url: "/",
          method: "POST",
          data: {
            'nozzle': 'server_url',
          }
        })
          .then(ret => {
            let resData = ret.data;
            if (resData.code === 1) {
            window.open( resData.data , '_blank ');

            }
          });
      },
      schedule() {

        var i = 0;
        this.memberTimer = setInterval(function () {
          i += 1; // speed
          $('#new_reg').animate({
            scrollTop: i
          }, 1);
          if (i >= $('#new_reg').prop('scrollHeight') - $('#new_reg').height()) {
            i = 0;
          }
        }, 50);

        var j = 0;
        this.rechargeTimer = setInterval(function () {
          j += 1; // speed
          $('#reload_list').animate({
            scrollTop: j
          }, 1);
          if (j >= $('#reload_list').prop('scrollHeight') - $('#reload_list').height()) {
            j = 0;
          }
        }, 50);
      },
      pc_home() {
        let that = this;
        that.$http({
          url: "/",
          method: "POST",
          data: {
            'nozzle': 'pc_home',
          }
        })
          .then(ret => {
            let resData = ret.data;
            if (resData.code === 1) {
              that.swiperList = resData.data.banner;
              that.notice = resData.data.notice;
              that.news = resData.data.news;
              that.sz_kline_chart=resData.data.sz_kline_chart;
              that.sh_kline_chart=resData.data.sh_kline_chart;
              that.SinaGIF = that.sh_kline_chart.replace('{timeType}', 'min').replace('{channelType}', 'nsh000001');
              // localStorage.setItem('encript_public_key',resData.data.encript_public_key)
              if (resData.data.popup.popup_status == 1){
                that.popupStatus = true;
                that.popup = resData.data.popup
              }else{
                that.popupStatus = false;
              }
              sessionStorage.setItem("news", JSON.stringify(that.news));
            }
          });
      },
      show_trade_chart_by_type($type) {
        this.trade_exchange_type = $type;
        this.show_trade_chart();
      },
      show_trade_chart_by_time($time) {
        this.trade_chart_type = $time;
        this.show_trade_chart();
      },
      show_trade_chart() {
        let that = this;
        that.SinaGIF = that.get_stock_chart(that.trade_exchange_type, that.trade_chart_type)
      },
      get_stock_chart(tradeChannel, timeType) {
         let channelType = "sh000001";
 
           if (tradeChannel === 'SH') {
             channelType = timeType === 'min' ? "nsh000001" : "sh000001";
             return this.sh_kline_chart.replace("{timeType}", timeType).replace("{channelType}", channelType) + `?${Date.now()}`
             // return `https://image.sinajs.cn/newchart/${timeType}/n/${channelType}.gif?${new Date().getTime()}`;

           } else {
             channelType = "sz399001";
             return this.sz_kline_chart.replace("{timeType}", timeType).replace("{channelType}", channelType) + `?${Date.now()}`
             //  return `https://image.sinajs.cn/newchart/${timeType}/${channelType}.gif?${new Date().getTime()}`;

           }
 
       },
      //去新闻详情
      toDetail(i) {
        sessionStorage.setItem("activenewsindex", i);
        this.$router.push({
          name: "Newsdetails"
        })


        // this.$router.push({
        //   name:'Newsdetails',
        //   query: {id:id}
        // })
      },
      get_stock_up() {
        let that = this;
        // $.ajax({
        //   cache: true,
        //   url: "https://hq.sinajs.cn/list=new_all_changepercent_up",
        //   type: "GET",
        //   dataType: "script",
        //   success: function () {
        //     let elements = eval('hq_str_new_all_changepercent_up');
        //     that.upStock = eval("("+elements+")");
        //     //console.log(elements);
        //   }
        // });
        that.$http({
          url: "/",
          method: "POST",
          data: {
            'nozzle': 'stock_page_data',
            'action':'stock_hs_up',
            'page':1,
            'num':10
          }
        })
          .then(ret => {
            let resData = ret.data;
            if (resData.code === 1) {
              that.upStock = resData.data;
            }
          });
      },
      get_stock_down() {
        let that = this;
        // $.ajax({
        //   cache: true,
        //   url: "https://hq.sinajs.cn/list=new_all_changepercent_down",
        //   type: "GET",
        //   dataType: "script",
        //   success: function () {
        //     let elements = eval('hq_str_new_all_changepercent_down');
        //     that.downStock = eval("("+elements+")");
        //   }
        // });
        that.$http({
          url: "/",
          method: "POST",
          data: {
            'nozzle': 'stock_page_data',
            'action':'stock_hs_down',
            'page':1,
            'num':10
          }
        })
          .then(ret => {
            let resData = ret.data;
            if (resData.code === 1) {
              that.downStock = resData.data;
            }
          });
      },
      QrCode(url) {
        new QRCode('floatQrCode', {
          width: 100,
          height: 100,
          text: url, // 二维码地址
        })
      },
      changeNoticeStatus(){
        this.noticeStatus = true;
      },
      getInfoData() {
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "web_common"
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              var data = res.data.data;
              that.info = data;
              let qq = that.info.qq;
              let temp = [];
              for (let i = 0,len = qq.length;i < len; i ++){
                if (qq[i] !== ''){
                  temp.push([qq[i],'tencent://Message/?Uin='+qq[i]+'&Site=hk9999&Menu=yes'])
                }
              }
              that.info.qq = temp;
              that.QrCode(data.codes[0].code);
              that.profitBanner = that.info.home_profit_banner;
            } else if (res.data.code == 0) {
              that.$message.error(res.data.msg);
            }
          });
      },
      loadChatPopup() {
           // if (this.$store.state.loginType){
            if(false){
              this.chatPopupStatus = true;
              this.user_number = localStorage.getItem("user_number");
              this.chatToken = localStorage.getItem("chatToken");
              this.server_url = this.$chatApiURL+'/webclientmobile/index.action?account='+this.user_number+'&chatToken='+this.chatToken;
           }
           else {
              this.chatPopupStatus = false;
              this.serverUrl();
           }
      }
    },
    mounted: function () {
      this.schedule();
      this.pc_home();
      this.get_stock_up();
      this.get_stock_down();
      this.getInfoData();
      // this.serverUrl();
      this.realNameConfig();

      let code = this.$route.query.code;


      if(code){
        window.sessionStorage.setItem("rePhone", code);
      }


      $(document).ready(function () {
        $('#atop').click(function () {
          $('html,body').animate({
            scrollTop: '0'
          })
        })




        $(".flo_2").mouseover(function () {
          $(this).css({'width': '181px'});
          // $(this).find('.ke_info').css();
        }).mouseout(function () {
          $(this).css({'width': '60px'});
        });
        $(".flo_3").mouseover(function () {
          $('.wxqrc').show();
        }).mouseout(function () {
          $('.wxqrc').hide();
        });
        $(".flo_w").mouseover(function () {
          $('.appqrc').show();
        }).mouseout(function () {
          $('.appqrc').hide();
        });
        $(".flo_qq,.qqqrc").mouseover(function () {
          $('.qqqrc').show();
        }).mouseout(function () {
          $('.qqqrc').hide();
        });

      });

    },
    beforeDestroy() {
      clearTimeout(this.memberTimer);
      clearTimeout(this.rechargeTimer);
    }
  };
</script>
<style scoped>
  @import url("./../assets/css/home.css");
  @import url("./../assets/css/footer.css");
  @import url("./../assets/css/style.css");

  body {
    height: auto !important;
  }

  .swiper-img {
    width: 100%;
    height: 400px;
  }

  .wrapper {
    max-width: 1200px;
    min-width: 1000px;
    margin: auto;
  }

  .text-danger {
    color: red;
  }

  /*跑马灯start*/
  .scroll_news {
    height: 40px;
    width: 100%;
    border: #e3e3e3 1px solid;
    box-shadow: #979595 2px 2px 2px 2px;
  }

  .scroll_news span {
    float: left;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    padding-left: 10px;
    margin-right: -70px;
  }

  .scroll_con {
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    padding-left: 40px;
    float: left;
    margin-left: 70px;
  }

  .scroll_con a {
    color: #000000;
  }

  .scroll_con a:hover {
    color: #FF0000;
  }

  /*跑马灯end*/


  /*提示start*/
  .newbee {
    padding: 20px 0;
    background-color: #fff;
    padding-left: 20px;
    margin-top: 20px;
  }

  .newbee .item {
    width: 25%;
    float: left;
    padding-left: 20px;
    cursor: pointer;
  }

  .newbee .item .figure {
    float: left;
    /*margin-right: 15px;*/
  }

  .newbee .item .item-body {
    overflow: hidden;
  }

  .newbee .item:hover .item-body div {
    color: #bb9767;
  }

  .newbee .item .item-body .title {
    font-size: 18px;
    color: #333333;
    line-height: 2;
  }

  .newbee .item .item-body .text {
    color: #999999;
  }

  .newbee .item:last-child .item-body {
    border: none;
  }

  .newbee .figure {
    height: auto;
    overflow: hidden
  }

  .newbee .item:hover img {
    -webkit-transform: rotateY(360deg);
    -moz-transform: rotateY(360deg);
    -ms-transform: rotateY(360deg);
    -o-transform: rotateY(360deg);
    transform: rotateY(360deg)
  }

  .newbee .item img {
    width: 60px;
    height: 60px;
    margin-right: 24px;
    background-position: -122px -137px;
    -webkit-transition: all .4s linear;
    -moz-transition: all .4s linear;
    -ms-transition: all .4s linear;
    -o-transition: all .4s linear;
    transition: all .4s linear
  }

  /*提示end*/

  /*配资start*/
  .w1200 {
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }

  .main_peizi {
    height: 475px;
  }

  .main_peizi a {
    font-size: 16px;
  }

  .main_peizi a:hover {
    color: white;
  }

  .main_peizi1 {
    width: 268px;
    height: 448px;
    border: 1px solid #FF646E;
    border-radius: 10px;
    margin-top: 25px;
    background: #FFF5F5;
    transition: all 0.2s;
    position: relative;
    top: 0px;
    overflow: hidden;
    box-sizing: border-box;
  }

  .main_peizi1:hover {
    top: -15px;
    box-shadow: 0 0 20px 5px #EAD0D3;
  }

  .main_peizi1_t {
    height: 75px;
    background: linear-gradient(to bottom, #FF646E, #FF121D);
    line-height: 90px;
    text-align: center;
    color: #fff;
    font-size: 31px;
  }

  .main_peizi1_t img {
    position: relative;
    top: -12px;
  }

  .main_peizi1_t span {
    position: relative;
    top: -12px;
  }

  .main_peizi1_c1 {
    border-bottom: 1px dashed #FF646E;
    height: 138px;
    width: 235px;
    margin: 0 auto;
  }

  .main_peizi1_c1_left {
    text-align: left;
    margin-left: 15px;
    margin-top: 40px;
  }

  .main_peizi1_p1 {
    font-size: 14px;
    color: #4D4D4D;
    height: 18px;
    line-height: 18px;
    overflow: hidden;
  }

  .main_peizi1_p2 {
    color: #FF394B;
    font-size: 22px;
    margin-top: 8px;
  }

  .main_peizi1_c1_right {
    text-align: center;
    margin-top: 40px;
  }

  .main_peizi1_c2 {
    height: 60px;
    line-height: 50px;
    overflow: hidden;
    width: 235px;
    margin: 0 auto;
  }

  .main_peizi1_c2 span {
    color: #FF394B;
    font-size: 24px;
    float: left;
  }

  .main_peizi1_c2 em {
    font-size: 14px;
    float: right;
    margin-right: 5px;
  }

  .main_peizi1_c2 div {
    font-size: 14px;
    float: right;
    margin-right: 5px;
  }

  .main_peizi1_c3 {
    padding-top: 19px;
  }

  .main_peizi1_a {
    display: block;
    font-size: 14px;
    color: #fff;
    width: 210px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin: 0 auto;
    background: #FF414B;
    margin-top: 12px;
    border-radius: 5px;
  }

  .main_peizi1_p3 {
    text-align: center;
    height: 18px;
    line-height: 18px;
    font-size: 14px;
    color: #EB6972;
    margin-top: 10px;
  }

  .main_peizi2 {
    margin: 25px 40px 0;
    border: 1px solid #C69C6E;
    box-shadow: none;
    background: #F9F4ED;
  }

  .main_peizi2 .main_peizi1_t {
    background: linear-gradient(to bottom, #D1B08A, #9B6E44);
  }

  .main_peizi2 .main_peizi1_a {
    background: #AF875E;
  }

  .main_peizi2 .main_peizi1_c1 {
    border-bottom: 1px dashed #C69C6E;
  }

  .main_peizi3 {
    border: 1px solid #5285AF;
    box-shadow: none;
    background: #EFF6F9;
  }

  .main_peizi3 .main_peizi1_t {
    background: linear-gradient(to bottom, #5285AF, #165085);
  }

  .main_peizi3 .main_peizi1_a {
    background: #246395;
  }

  .main_peizi3 .main_peizi1_c1 {
    border-bottom: 1px dashed #5285AF;
  }

  .main_peizi4 {
    margin-left: 40px;
  }

  .main_peizi4 {
    border: 1px solid #c67b18;
    box-shadow: none;
    background: #fffaf3;
  }

  .main_peizi4 .main_peizi1_t {
    background: linear-gradient(to bottom, #fbb65d, #c67b18);
  }

  .main_peizi4 .main_peizi1_a {
    background: #e2a34e;
  }

  .main_peizi4 .main_peizi1_c1 {
    border-bottom: 1px dashed #c67b18;
  }

  /*.main_peizi4 .main_peizi1_c1_left{margin-left:0px; line-height:40px; margin-top:20px; text-align: center;width: 235px}
.main_peizi4 .main_peizi1_c1_left{text-align:left; margin-left:15px; margin-top:40px;}*/
  .fr {
    float: right !important;
  }

  .fl {
    float: left !important;
  }

  .txt-r {
    text-align: right !important;
  }

  .txt-l {
    text-align: left !important;
  }

  .txt-c {
    text-align: center !important;
  }

  /*配资end*/

  /*指数start*/
  .nav {
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
  }

  .nav-link {
    border-radius: 4px;
  }

  .text-primary {
    color: #007bff !important;
  }

  .text-success {
    color: #28a745 !important;
  }

  .text-right {
    text-align: right !important;
  }

  .table {
    width: 100%;
    max-width: 100%;
  }

  th {
    text-align: inherit;
  }

  /*指数end*/

  .down_ad {
    display: block;
  }

  /*今日注册/充值*/
  .wrapper {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }

  .plan3 .plan-right {
    float: left;
    background-color: #f3f3f3;
    width: 989px;
    height: 389px;
    color: #666666;
  }

  .plan3 .plan-right .text {
    padding: 60px 0 0 95px;
    background: none;
    float: left;
  }

  .plan3 .plan-right .text p:nth-child(1) {
    font-size: 22px;
  }

  .plan3 .plan-right .text p {
    font-size: 16px;
  }

  .plan3 .plan-right .phone {
    float: left;
    margin-top: 17px;
    margin-right: 130px;
    margin-left: 6px;
  }

  .plan3 .plan-right .code {
    float: left;
    margin-top: 50px;
    text-align: center;
    margin-left: 63px;
  }

  .plan3 .plan-right .code img {
    margin-bottom: 36px;
  }

  .plan3 .plan-right .code .btn {
    width: 172px;
    display: block;
    background: #000000;
    color: #fff;
    border-radius: 0;
    height: 40px;
    line-height: 40px;
    border-radius: 3px;
    margin-bottom: 17px;
    position: relative;
    text-indent: 44px;
    font-size: 12px;
  }

  .plan3 .plan-right .code .btn:nth-child(2) {
    background: rgba(42, 171, 0, 0.97);
  }

  .plan3 .plan-right .code .btn::before {
    content: '';
    display: block;
    width: 18px;
    height: 24px;
    background-repeat: no-repeat;
    position: absolute;
    left: 38px;
    top: 10px;
    background-size: 47px;
  }

  .plan3 .plan-right .code .btn:nth-child(2)::before {
    background-position: -22px 0;
  }

  .plan3 .app-d {
    width: 300px;
    height: 100%;
    float: left;
    /*border: 1px solid;*/
    margin-left: 50px;
  }

  .plan3 .app-d .active a {
    color: red;
  }

  .plan3 .app-d a {
    color: black;
  }

  .plan3 .app-d .jxrjxz {
    height: 52px;
    line-height: 52px;
    text-align: center;
    font-size: 21px;
  }

  .plan3 .app-d .jxrjp {
    width: 70%;
    margin: 0 auto;
    text-align: center;
    line-height: 22px;
    margin-top: 25px;
    font-size: 15px;
  }

  .plan3 .app-d .jxrjlogo {
    width: 100px;
    margin: 0 auto;
    margin-top: 25px;
  }

  .plan3 .app-d .jxrjlogo img {
    width: 100%;
  }

  .plan3 .app-d .jxrjpc {
    width: 135px;
    margin: 0 auto;
    margin-top: 35px;
  }

  .plan3 .app-d .jxrjpc button {
    width: 100%;
    height: 40px;
    border: none;
    border-radius: 10px;
    background: #f44336;
    color: #fff;
    cursor: pointer;
  }

  .plan-right .pr-left {
    width: 330px;
    height: 100%;
    float: left;
    background-color: #fff;
    /*border: 1px solid;*/
  }

  .plan-right .pr-left .prl-block {
    width: 360px;
    /* border: 1px solid; */
    margin: 0 auto;
    height: 100%;
  }

  .plan-right .pr-left .prl-block .prl-title {
    font-size: 21px;
    height: 55px;
    line-height: 15px;
    border-bottom: 1px solid #eee;
  }

  .prl-title p:first-child {
    padding-left: 16px;
    padding-top: 22px;
    font-size: 20px;
  }

  .plan-right .pr-left .prl-block .prl-li {
    height: 310px;
    overflow: hidden;
    /* border: 1px solid red; */
    padding-left: 10px;
    padding-right: 13px;
    /*border: 1px solid red;*/
  }

  .plan-right .pr-left .prl-block ul li {
    font-size: 16px;
    padding: 9px 0px;
  }

  .plan-right .pr-left .prl-block ul li .li-l {
    float: left;
    line-height: 24px;
  }

  .plan-right .pr-left .prl-block ul li .li-r {
    float: right;
    color: #FF465A;
  }

  .plan-right .pr-left .prl-block ul li {
    font-size: 16px;
    padding: 9px 0px;
  }

  .pb6 .pb6-r .gonggaoBox .dd p span {
    float: left;
    padding-left: 30px;
    padding-top: 15px;
    font-size: 20px;
    color: #333333;
    /*background: url(/public/web/images/add/gongao_icon.png);*/
    background-repeat: no-repeat;
    background-position: 23px 31px;
    background-size: 26px;
    cursor: pointer;
  }

  .pb6 .pb6-r .gonggaoBox .dd .dd_line {
    width: 100%;
    height: 55px;
    border-bottom: 1px solid #eee;
    background: #fff;
  }

  .pb6 .pb6-r .gonggaoBox .dd p span.active {
    color: red;
  }

  .pb6 .pb6-r .gonggaoBox .dd {
    width: 441px;
    height: 389px;
    background-color: #fff;
    /* border: 1px solid #eee; */
  }

  .list-group {
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
  }

  .dd_line {
    margin-top: 0;
    margin-bottom: 1rem
  }

  .list-group-item {
    /*position: relative;
    display: block;
    margin-bottom: -1px;*/
    background-color: #fff;
    border-bottom: 1px solid rgba(0, 0, 0, .125);
  }

  .list-group-item:last-child {
    border-bottom: 0;
  }

  /*注册登录入口*/
  .homeIndex .banner .wrapOne {
    width: 1190px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    z-index: 99;
    margin-top: 50px;
  }

  .homeIndex .banner .entrance {
    width: 340px;
    /*
    height: 254px;
    background: rgba(0,0,0,.2);
    */
    background-color: rgba(255, 255, 255, 0.8);
    /*background: #fff;*/
    border-radius: 15px;
    position: absolute;
    top: 15px;
    right: 0;
    text-align: center;
  }

  .goAccount {
    margin-top: 20px;
    /*background: #EFF1F0;*/
    border-radius: 0 0 15px 15px;
    /*box-shadow: inset 0 35px 10px rgba(0, 0, 0, 0.1);*/
  }

  .homeIndex .banner .entrance .register.selected {
    display: block;
  }

  .homeIndex .banner .entrance .register .head {
    font-size: 22px;
    font-weight: 400;
    color: #000;
    padding: 35px 0 20px;
    margin-top: 0;
  }

  .homeIndex .banner .entrance .register .percent {
    font-size: 22px;
    color: #ff6f20;
  }

  .btn {
    display: inline-block;
    padding: 6px 12px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;
  }

  .homeIndex .banner .entrance .btn {
    /*width: 248px;*/
    height: 40px;
    border: 1px solid #e35353;
    background-color: #e35353;
    color: #fff;
    background: 0 0;
    font-size: 18px;
    margin-bottom: 30px;
    background: #e35353;
    margin-top: 28px;
  }

  .homeIndex .banner .entrance .btn:hover {
    color: #fff;
    background: #e35353
  }

  .homeIndex h1, .homeIndex li, .homeIndex p, .homeIndex ul {
    margin: 0;
    padding: 0;
  }

  .homeIndex .banner .entrance .tt {
    font-size: 12px;
    color: #fff;
  }

  .operate-flow {
    padding: 10px 20px 25px 35px;
    background-color: #fff;
    box-sizing: border-box;
    margin: 20px 0px;
  }

  .operate-flow .item {
    float: left;
    width: 110px;
    text-align: center;
    cursor: pointer;
  }

  .operate-flow .item .title {
    font-size: 16px;
  }

  .operate-flow .item .icon {
    height: 90px;
    position: relative;
  }

  .operate-flow .item .icon img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin-left: -26px \9;
    margin-top: -25px \9;
  }

  .operate-flow .gutter {
    float: left;
    width: 60px;
    height: 105px;
    background: url(../assets/img/double-arr.png) center center no-repeat;
  }

  .newbee {
    padding: 20px 0;
    background-color: #fff;
    padding-left: 20px;
    margin-top: 20px;
  }

  .newbee .item {
    width: 25%;
    float: left;
    padding-left: 20px;
    cursor: pointer;
  }

  .newbee .item .figure {
    float: left;
    margin-right: 15px;
  }

  .newbee .item .item-body {
    overflow: hidden;
  }

  .newbee .item:hover .item-body div {
    color: #bb9767;
  }

  .newbee .item .item-body .title {
    font-size: 18px;
    color: #333333;
    line-height: 2;
  }

  .newbee .item .item-body .text {
    color: #999999;
  }

  .newbee .item:last-child .item-body {
    border: none;
  }

  .newbee .figure {
    height: auto;
    overflow: hidden
  }

  .newbee .item:hover img {
    -webkit-transform: rotateY(360deg);
    -moz-transform: rotateY(360deg);
    -ms-transform: rotateY(360deg);
    -o-transform: rotateY(360deg);
    transform: rotateY(360deg)
  }

  .newbee .item img {
    width: 60px;
    height: 60px;
    margin-right: 24px;
    background-position: -122px -137px;
    -webkit-transition: all .4s linear;
    -moz-transition: all .4s linear;
    -ms-transition: all .4s linear;
    -o-transition: all .4s linear;
    transition: all .4s linear
  }

  .float {
    top: 25%;
    width: 60px;
    min-height: 153px;
    position: fixed;
    z-index: 999;
    right: 60px;
  }

  .float li {
    list-style: none;
  }

  .float ul li {
    width: 60px;
    height: 66px;
    border-bottom: 0px solid #e6e6e6;
    padding: 0;
    margin-bottom: 4px;
    position: relative;
  }

  .float ul li a {
    position: absolute;
    right: 1px;
    top: 0px;
    transition: all 0.3s;
    color: #fff;
    line-height: 66px;
    overflow: hidden;
    font-size: 14px;
    background-position: center 6px;
    /* text-indent: 70px; */
  }

  .float ul li a .ke_tit {
    position: absolute;
    top: 42px;
    left: 0px;
    width: 60px;
    text-align: center;
    text-indent: 0;
    line-height: 0.9;
  }

  .float ul li a .ke_info {
    display: block;
    position: absolute;
    left: 60px;
    height: 66px;
    background: #fff;
    color: #FF465A;
    padding-right: 10px;
    padding-left: 5px;
    width: 181px;
    /* background: rgba(255,255,255,0.3); */
    box-shadow: 0px 2px 4px 0px rgba(255, 70, 90, 0.3);
    font-size: 15px;
  }

  .flo_1 {
    width: 60px;
    height: 66px;
    display: block;
    background: #ff465a url(../assets/img/float_5.png) no-repeat;
  }

  .flo_2 {
    width: 60px;
    height: 66px;
    display: block;
    background: #ff465a;
  }

  .flo_2 .ke_tit {
    background: url(../assets/img/float_7.png) 15px 0 no-repeat;
    padding-top: 35px;
    top: 6px !important;
  }

  .flo_3 {
    width: 60px;
    height: 66px;
    display: block;
    background: #ff465a url(../assets/img/float_9.png) no-repeat;
  }

  .flo_4 {
    width: 60px;
    height: 66px;
    display: block;
    background: #ff465a url(../assets/img/float_8.png) no-repeat;
  }

  .flo_w {
    width: 60px;
    height: 66px;
    display: block;
    background: #ff465a url(../assets/img/float_6.png) no-repeat;
  }

  .flqrc {
    display: none;
    position: absolute;
    padding: 7px 7px;
    background: #fff;
    box-shadow: 1px 1px 10px 0px #ccc;
  }

  .flqrc img {
    width: 100px;
  }

  .flqrc.wxqrc {
    top: 140px;
    right: 60px;
  }

  .flqrc.appqrc {
    top: 209px;
    right: 60px;
  }

  .flo_qq {
    width: 60px;
    height: 66px;
    display: block;
    background: #ff465a url(../assets/img/float_10.png) no-repeat;
  }

  .flqrc.qqqrc {
    width: 170px;
    text-align: center;
    top: 140px;
    right: 60px;
    font-size: 13px;
  }

  .footer-row ul {
    margin: 0;
    padding: 0;
    font-size: 16px;
    line-height: 27px;
    text-align: center;
  }

  .footer-row ul li {
    list-style: none;
  }

  .footer-row ul li a {
    color: #fff;
  }

  .footer-row .t {
    font-size: 18px;
    font-weight: bolder;
    padding-bottom: 5px;
  }
  .flo_ai {
    width: 60px;
    height: 66px;
    display: block;
    background: #ff465a url(../assets/img/robot.png) no-repeat;
  }
  .popupContent >>> img{
    width: 100%;
  }

</style>
<style>
 #chatPopupId .el-dialog__header {
    text-align: center !important;
  }
 #chatPopupId .el-dialog {
    margin-top:0px !important;
    margin-bottom:0px;
 }
</style>





// WEBPACK FOOTER //
// src/components/home.vue